<template>
    <div class="browseHistoryRemind">
        <div class="browse-mask" v-if="isShow"></div>
        <transition name="scale">
            <div v-if="isShow" class="content" :data-spm="spmCCode" data-spm-top="init">
                <span class="title" data-spm-type="content">{{ title }}</span>
                <span class="close-btn" @click="handleClose"></span>
            </div>
        </transition>
    </div>
</template>

<script>
import { getUserInfo } from '@/js/request/uisRequest'
import localstorageUtil, { localStorageKey } from '@/utils/localstorageUtil'
import { isUnloginUserShowRemind, isLoginUserShowRemind } from '@/utils/browseHistory'

export default {
    name: 'browseHistoryRemind',
    data() {
        return {
            isShow: false,
            isLogin: false,
        }
    },
    computed: {
        title(){
            return this.isLogin ? '点此去个人中心，可查看您的浏览历史' : '点此登录，可查看您的浏览历史'
        },
        spmCCode(){
            return 'history'
        }
    },
    methods: {
        handleClose(){
            this.isShow = false
        }
    },
    async created(){
        try {
            const res = await getUserInfo()
            this.isLogin = res?.code == 1 && res?.data
        } catch (error) { 
            this.isLogin = false
        } finally {
            if(this.isLogin){
                this.isShow = isLoginUserShowRemind()
            }else{
                this.isShow = isUnloginUserShowRemind()
            }
        }
    },
    mounted(){
    },
    watch: {
        isShow(val){
            if(val){
                const browseRemindNum = localstorageUtil.getItem(localStorageKey.browseHistoryRemindNum) || 0
                localstorageUtil.setItem(localStorageKey.browseHistoryRemindNum, browseRemindNum + 1)
                const timeout = setTimeout(() => {
                    this.isShow = false
                    clearTimeout(timeout)
                },7000)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.browseHistoryRemind{
    position: fixed;
    bottom: 54PX;
    left: 0px;
    right: 0px;
    z-index: 1001;
    .browse-mask{
        position: absolute;
        bottom: -7PX;
        left: 0px;
        right: 0px;
        height: 100PX;
        background: linear-gradient( 180deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);
        z-index: 1;
        pointer-events: none;
    }
    .content{
        position: absolute;
        left: 13PX;
        right: 13PX;
        bottom: 0PX;
        height: 18PX;
        display: flex;
        box-sizing: content-box;
        align-items: center;
        justify-content: space-between;
        padding:7PX 12PX;
        background: #F2F2F2;
        transition: all 0.3s ease-in-out;
        transform-origin: 12PX 38PX;
        opacity: 1;
        transform: scale(1);
        z-index: 2;
        border-radius: 4PX;
        &::after{
            content: '';
            position: absolute;
            left: 12PX;
            top: 31PX;
            border-left: 6PX solid transparent;
            border-right: 6PX solid transparent;
            border-top: 6PX solid #F2F2F2;
            width: 0;
            height: 0;
        }
    }
    .title{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 13PX;
        color: #333333;
        line-height: 18PX;
        text-align: left;
        font-style: normal;
    }
    .close-btn{
        width: 12PX;
        height: 12PX;
        background: url('../less/images/icon_close_999999.png') no-repeat center;
        background-size: contain;
    }
    .scale-enter-active,.scale-leave,.scale-leave-active{
        transition: all 0.3s ease-in-out;
        transform-origin: 12PX 38PX;
        opacity: 1;
        transform: scale(1);
    }
    .scale-enter,.scale-leave-to{
        opacity: 0;
        transform: scale(0);
    }
}
</style>